import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../../../components/Configurer";
import ProfileImage from "../../../components/partials/ProfileImage";
import ItemModal from "../../../modals/ItemModal";
import HttpServices from "../../../utils/Http.services";
import { checkTextTranslation, checkTranslation, conditionalWidth, imageAddress, pathMaker, setObject, translate } from "../../../utils/useful";
import DataGrid from "../../../components/DataGrid";
import Pagination from "../../../components/Pagination";
import OptionsListModal from "../../../modals/OptionsListModal";
import RemoveConfirmationModal from "../../../modals/RemoveConfirmationModal";
import FormViewer from "../../../components/FormViewer";
import SettingsViewer from "../../../components/SettingsViewer";


class SettingsGeneral extends React.Component {


    openEditModal = (prop, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })

        // console.log("remove")
    }

    state = {
        data: [],
        actions: {
            add: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal },
            edit: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
        headers: [

            { key: 'image', type: 'ProfileImageRowInput', col: '12', information: { label: '{{lang}}Image', placeholder: '{{lang}}profileImage', required: false, inputClass: 'a' } },
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true, }, showMain: true },
            { key: 'family', type: 'TextInput', col: '12', information: { label: '{{lang}}family', placeholder: '{{lang}}family', required: false, }, showMain: true },
            { key: 'family', type: 'TextInput', col: '12', information: { label: '{{lang}}Address', placeholder: '{{lang}}family', required: false, }, showMain: true },
            { key: 'family', type: 'TextInput', col: '12', information: { label: '{{lang}}Phone number', placeholder: '{{lang}}family', required: false, }, showMain: true },
            { key: 'family', type: 'TextInput', col: '12', information: { label: '{{lang}}Email', placeholder: '{{lang}}family', required: false, }, showMain: true },
            { key: 'family', type: 'TextInput', col: '12', information: { label: '{{lang}}Location', placeholder: '{{lang}}family', required: false, }, showMain: true },
            { key: 'family', type: 'TextInput', col: '12', information: { label: '{{lang}}Website', placeholder: '{{lang}}family', required: false, }, showMain: true },
            { key: 'family', type: 'TextInput', col: '12', information: { label: '{{lang}}Telegram', placeholder: '{{lang}}family', required: false, }, showMain: true },

            // { key: 'fullname', type: 'TextInput', col: '12', information: { label: '{{lang}}fullname', placeholder: '{{lang}}fullname', required: false, }, showMain: true },
            // { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: true }, showMain: true },
            // { key: 'status', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}status', required: true, type: 'local', default: '0', items: [{ title: "Unpaid", value: 'U', color: '#789' }, { title: "Paid", value: 'P', color: '#00CD74' }, { title: "{{lang}}Partially Paid", value: 'PP', color: '#00CD74' }, { title: "{{lang}}Draft", value: 'D', color: '#789' },] }, showMain: true, inExport: true },
            // { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.dueDate', placeholder: '{{lang}}applets.accounting.dueDate', required: false }, showMain: true },
            // { key: 'custome', type: 'SwitchInput', isEditing: true, information: { inputClass: 'no', label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'fullname', image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: true }, showMain: true },
            // { key: 'customer1', type: 'PageIndicator', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'fullname', image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: true }, showMain: true },

        ],
        currentPage: 0,
        // limit: 10
    }


    componentDidMount() {
        // this.init()
    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            // setTimeout(() => {
            // this.init()
            // }, 500);
        }
    }


    // init() {
    //     if (this.props.page) {
    //         this.setState({ data: [] }, () => {
    //             this.fetchData(true)
    //         })
    //     }
    // }

    // fetchData = (getCount) => {

    //     this.setState({ isLoadingData: true })
    //     let body = {}
    //     let page = this.props.page
    //     body.page = page.key
    //     body.limit = this.state.limit
    //     body.skip = this.state.currentPage

    //     if (page.filter) {
    //         body = { ...body, ...page.filter }
    //         // console.log(body)
    //     }

    //     if (this.state.totalCount == null || getCount) {
    //         body.getCount = true
    //     }

    //     for (const [key, value] of Object.entries(body)) {
    //         if (/\{\{(.*?)\}\}/.test(value)) {
    //             if (this.props.variables) {
    //                 body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //                 if(typeof body[key] == 'object'){
    //                     body[key] = body[key]._id
    //                 }
    //             }
    //         }
    //     }

    //     console.log(body)

    //     HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingData: false })

    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
    //             return
    //         }
    //         console.log(fetchResult)
    //         this.setState({ data: fetchResult.info })

    //         if (fetchResult.count) {
    //             this.setState({ totalCount: fetchResult.count })
    //         }
    //     })
    // }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })


        })

    }


    saveSetting = (key, value, files, cb) => {

        this.setState({ isLoadingRemove: true })
        let page = this.props.page
        let body = { targetHub: '{{targetHub}}' }
        console.log(this.props.variables)
        body.change = { key, value }

        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    if (typeof body[key] == 'object') {
                        body[key] = body[key]._id
                    }
                }
            }
        }

        let filesObject = null
        if (files) {
            filesObject = { [key]: value, '**files': { [key]: files } }
        }
        HttpServices.handleFiles(null, filesObject, () => {
            console.log(filesObject)
            if (files) {


                // if (Array.isArray(fileInfo)) {
                //     newParams[key] = Array.isArray(newParams[key]) ? newParams[key] : []
                //     setObject(newParams, key, [...fileInfo], true)
                // } else {
                //     setObject(newParams, key, fileInfo)
                // }
                body.change.value = filesObject[key]
            }

            // console.log(body)
            HttpServices.request('updateProfileSettings', body, (fetchResult, fetchError) => {
                this.setState({ isLoadingRemove: false })
                cb()
                console.log(fetchResult)
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: fetchError.message })
                    return
                }
                this.props.settingsUpdated(fetchResult.info)
                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.updatedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })


            })
        })

    }

    itemAdded = (newItem) => {
        let data = this.state.data
        data.splice(0, 0, newItem)
        console.log(newItem)
        console.log(data)
        this.setState(data)
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'SettingsGeneral') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }
    itemEdited = (editedItem) => {
        // console.log(editedItem)
        let data = this.state.data
        this.state.data.forEach((element, index) => {
            let id = element.id ?? element._id
            let currentId = this.state.currentItem.id ?? this.state.currentItem._id
            if (id === currentId) {
                // console.log(id)
                data[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ data }, () => {
            // console.log(editedItem)
            // console.log(data)
            // this.TableViewer.forceUpdateData()
        })
    }

    // updateData = (data) => {
    //     this.setState(data)
    // }


    // openAddNew = () => {
    //     if (this.props.page?.addNew) {
    //         this.props.history.push(pathMaker(this.props.page?.addNew + '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key)))
    //     } else {
    //         this.openEditModal()
    //     }
    // }


    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            this.fetchData()
        })
    }


    // openOptions = (prop, index) => {
    //     // console.log(prop)
    //     let options
    //     if (prop.status == -1) {
    //         options = [
    //             { name: 'View', icon: '/images/eye.svg', function: this.openView },
    //             { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
    //             { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
    //             { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
    //         ]
    //     } else {
    //         options = [
    //             { name: 'View', icon: '/images/eye.svg', function: this.openView },
    //             { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
    //             { name: 'Disconnect', icon: '/images/settings.svg', function: this.fetchDisconnect },

    //         ]
    //     }

    //     this.setState({ options, currentItem: prop, currentIndex: index }, () => {
    //         this.optionsModal.modal.showModal()
    //     })

    // }


    openRemoveModal = () => {
        this.removeModal.modal.showModal()
    }


    openEdit = () => {
        this.itemModal.modal.showModal()
    }
    openView = () => {
        let id = this.state.currentItem._id
        this.props.history.push(pathMaker('/' + this.props.page.viewAddress + '/' + id))
    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data

            data.forEach((element, index) => {
                if (element._id == id) {
                    data.splice(index, 1)
                }
            });

            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })


        })

    }


    fetchDisconnect = () => {
        this.fetchStatus(-1)
    }

    fetchConnect = () => {
        this.fetchStatus(1)
    }



    fetchStatus = (newStatus) => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request('changeThingStatus', { "id": id, status: newStatus }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            // console.log(this.state.currentIndex)
            let data = this.state.data

            data.forEach((element, index) => {
                if (element._id == id) {
                    data[index].status = newStatus
                }
            });

            this.setState({ data })
            // this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.actionSuccesfully', description: '{{lang}}info.dataActionSuccessfully' })

        })
    }

    changePage = (page) => {
        this.props.changePage(page)
        // console.log("changePage")
    }

    render() {
        // console.log( this.props.page?.actions)

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        variables.changePage = this.changePage

        return (

            <div className="w-100">
                <div className="pb-5" style={{ backgroundColor: '#f0f0f0' }}>

                    <div>

                        <div className="flexc flex-column container pt-4"  >
                            <div style={{ width: '100%', maxWidth: 500 }}>

                                {conditionalWidth(this.props.width, { xs: true, sm: false }) && (
                                    <div className="flexc flex-wrap">


                                        <button className="flexc mb-2 py-1 px-2 mrd-2" onClick={() => this.props.changePage()} style={{ backgroundColor: '#e0e0e0', borderRadius: 8 }}>
                                            <img className="rotate-180" src={'/assets/icons/useful/angle-right.svg'} width={20} />
                                            <p className=" text-semibold text-small mrd-2">{translate("Back")}</p>
                                        </button>

                                        <div onClick={() => this.props.goToHub()} className='flexc pb-2 px-2  cursor-pointer' >
                                            <img src={imageAddress(this.props.applet?.user?.image, 'profile', 'small')} width="30px" height={'30px'} style={{ objectFit: 'cover', borderRadius: 100 }} />
                                            <div className='mld-2 flexc flex-wrap '>
                                                <h2 className="m-0 text-normal mb-0" >{this.props.applet?.user?.fullname}</h2>
                                                <div className="mx-1">
                                                    <p className="mt-0 text-smaller color-gray-1" >{translate('Settings')}</p>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                )}

                                <div style={{ backgroundColor: '#fff', width: '100%', maxWidth: 500, borderRadius: 12 }}>
                                    <div className="w-100 m-0">
                                        <div className="w-100 p-0" >
                                            <div className="p-0" style={{}}>
                                                <div className="flexcb pt-1 " style={{ flexWrap: 'wrap', backgroundColor: '#fafafa', borderRadius: '12px 12px 0px 0px' }}>
                                                    <div className="flexc px-3 py-3 w-100" style={{ borderRadius: 'px 0px 0px 0px', borderBottom: '1px solid #f2f6f8' }}>
                                                        <img className={'mrd-3'} style={{ width: 40 }} src={this.props.page?.icon} />
                                                        <div>
                                                            <p className="text-big font-bold m-0 text-capitalize" style={{ color: '#0d172a' }}>{checkTextTranslation(this.props.page?.title)}</p>
                                                            <p className="text-small m-0" style={{ color: '#89a' }} >{checkTextTranslation(this.props.page?.description)}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>



                                        <div className="w-100  mt-1 w-100 p-2 px-3">
                                            <div className="" style={{ width: '100%' }}>
                                                <SettingsViewer setData={this.setData} ref={el => this.form = el} saveSetting={this.saveSetting} headers={this.state.headers} initData={this.props.initData} errors={this.state.errors} formClass={'settings-theme '} inputClass={'modern-input'} variables={variables} />
                                            </div>
                                        </div>


                                    </div>


                                    <ItemModal
                                        ref={el => this.itemModal = el}
                                        page={this.props.page}
                                        headers={this.props.page?.headers}
                                        initData={this.state.currentItem}
                                        itemAdded={this.itemAdded}
                                        itemEdited={this.itemEdited}
                                    />




                                    <OptionsListModal ref={el => this.optionsModal = el}
                                        options={this.state.options}
                                    />

                                    <RemoveConfirmationModal ref={el => this.removeModal = el} confirmed={this.fetchRemove} />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingsGeneral);
